import { TileLayout } from '@/shared/enums';

export const ANIMATION_DELAY = 200;

export const SLIDE_SIZES = {
  [TileLayout.DEFAULT]: {
    xs: 2,
    sm: 3,
    md: 3,
    lg: 4,
    xl: 4,
    xxl: 5,
    xxxl: 5,
  },
  [TileLayout.LOGO]: {
    xs: 3,
    sm: 4,
    md: 5,
    lg: 6,
    xl: 7,
    xxl: 8,
    xxxl: 8,
  },
  [TileLayout.HERO_SLIDER]: {
    xs: 2,
    sm: 2,
    md: 2,
    lg: 2,
    xl: 2,
    xxl: 2,
    xxxl: 2,
  },
};
